module.exports = __webpack_public_path__ + "static/media/trees.84423cce.jpg";